<template>
  <div>
    <!-- 公告栏 -->
    <div class="inform-container" v-if="informList.length">
      <div class="inform">
        <div class="scroll-list">
          <div class="scroll" v-for="item in informList" :key="item.id">
            <div class="avatar-box">
              <img class="avatar" :src="item.join_user_pic" />
            </div>
            <div class="text">
              {{ item.join_user_name }}成功砍价到{{ item.proname
              }}{{ item.bargain_money }}元
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Inform",
  props: {
    informList: Array
  },
  data() {
    return {};
  },
  components: {},
  methods: {}
};
</script>

<style scoped lang="scss">
.inform-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9;
  height: .6rem;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.2);

  .inform {
    overflow: hidden;
  }
  .scroll-list {
    animation: 34s linear 0s normal none infinite change;
  }
  .scroll {
    padding-left: .2rem;
    height: 0.6rem;
    display: flex;
    align-items: center;
  }
  .text {
    flex: 1;
    color: #ffffff;
    font-size: 0.24rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .avatar-box {
    flex: 0 0 .42rem;
    width: 0.42rem;
    height: 0.42rem;
    border-radius: 50%;
    margin-right: 0.21rem;
    overflow: hidden;
  }
  .avatar {
    display: block;
    width: 100%;
    height: 100%;
  }
}
@keyframes change {
  0% {
    margin-top: 0;
  }
  5% {
    margin-top: 0;
  }
  8% {
    margin-top: -.6rem;
  }
  10% {
    margin-top: -.6rem;
  }
  13% {
    margin-top: -1.2rem;
  }
  15% {
    margin-top: -1.2rem;
  }
  18% {
    margin-top: -1.8rem;
  }
  20% {
    margin-top: -1.8rem;
  }
  23% {
    margin-top: -2.4rem;
  }
  25% {
    margin-top: -2.4rem;
  }
  28% {
    margin-top: -3rem;
  }
  30% {
    margin-top: -3rem;
  }
  33% {
    margin-top: -3.6rem;
  }
  35% {
    margin-top: -3.6rem;
  }
  38% {
    margin-top: -4.2rem;
  }
  40% {
    margin-top: -4.2rem;
  }
  43% {
    margin-top: -4.8rem;
  }
  45% {
    margin-top: -4.8rem;
  }
  48% {
    margin-top: -5.4rem;
  }
  50% {
    margin-top: -5.4rem;
  }
  53% {
    margin-top: -6rem;
  }
  55% {
    margin-top: -6rem;
  }
  58% {
    margin-top: -6.6rem;
  }
  60% {
    margin-top: -6.6rem;
  }
  63% {
    margin-top: -7.2rem;
  }
  65% {
    margin-top: -7.2rem;
  }
  68% {
    margin-top: -7.8rem;
  }
  70% {
    margin-top: -7.8rem;
  }
  73% {
    margin-top: -8.4rem;
  }
  75% {
    margin-top: -8.4rem;
  }
  78% {
    margin-top: -9rem;
  }
  80% {
    margin-top: -9rem;
  }
  83% {
    margin-top: -9.6rem;
  }
  85% {
    margin-top: -9.6rem;
  }
  88% {
    margin-top: -10.2rem;
  }
  90% {
    margin-top: -10.2rem;
  }
  93% {
    margin-top: -10.8rem;
  }
  100% {
    margin-top: -10.8rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/Inform.vue